<template>
  <v-container fluid>
    <v-layout row wrap v-if="role !== 'Supplier' && role !== ''">
      <v-flex xs12>
        <v-autocomplete :items="suppliers" v-model="supplierSelect" label="Select a Supplier" item-text="name" item-value="key" clearable></v-autocomplete>
      </v-flex>
      <template v-if="supplier === undefined">
        <v-flex class="text-xs-center" xs12>OR</v-flex>
        <v-flex xs12>
          <v-btn color="primary" dark block to="/Admin/Supplier">
            <v-icon>add</v-icon> Add New Supplier
          </v-btn>
        </v-flex>
      </template>
    </v-layout>
      <v-tabs
        v-model="activeTab"
        fixed-tabs
        slider-color="primary"
        style="width:100%;"
      >
        <v-tab
          v-for="n in ['Invoices', 'Jobs']"
          :key="n"
          ripple
        >
          <template v-if="n === 'Invoices' || supplier">
            {{ n }}
          </template>
        </v-tab>
        <v-tab-item key="Invoices">
          <v-card class="mt-2">
            <v-card-title>
              <div style="max-width:440px;">
                <v-select label="Filter Invoice Status" :items="invoiceStatuses" multiple v-model="invoiceStatusFilter" chips deletable-chips/>
              </div>
              <v-spacer></v-spacer>
              <v-text-field append-icon="search" label="Search" single-line hide-details v-model="searchInvoices"></v-text-field>
            </v-card-title>
            <v-data-table :headers="invoiceHeaders" :items="modifiedInvoices" :search="searchInvoices" :pagination.sync="pagination" item-key="id">
              <template slot="items" slot-scope="props">
                <tr>
                  <td><a @click="supplierSelect = props.item.supplier">{{props.item.supplierText}}</a></td>
                  <td @click.stop="props.expanded = !props.expanded">{{props.item.invoiceNumber}}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{props.item.submittedDate | formatDate}}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{props.item.lastActioned | formatDate}}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{props.item.lastUser}}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{props.item.lastNote}}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{props.item.currency}}{{props.item.cost}}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{props.item.statusText}}</td>
                  <td class="text-xs-right">
                    <v-btn v-if="role !== 'Supplier'" @click="openInvoiceStatus(props.item)" icon><v-icon color="success">edit</v-icon></v-btn>
                    <v-btn :href="props.item.attachedDocs[0].downloadUrl" target="_blank" icon><v-icon color="primary">mdi-file-document</v-icon></v-btn>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-layout justify-center>
                  <v-card class="ma-2" v-if="props.item.history">
                    <v-card-title>
                      Invoice History
                    </v-card-title>
                    <table style="width:100%;">
                      <thead class="text-xs-left">
                        <th>User</th>
                        <th>Status</th>
                        <th>Date</th>
                        <th>Note</th>
                      </thead>
                      <tbody>
                        <template v-for="(record, i) in props.item.history">
                          <tr :key="i">
                            <td>{{ record.user}}</td>
                            <td>{{ record.status | invoiceStatus }}</td>
                            <td>{{ record.date | formatDate}}</td>
                            <td>{{ record.note }}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </v-card>
                  <v-card class="ma-2" v-if="supplier">
                    <v-card-title>
                      Invoiced Jobs
                    </v-card-title>
                    <table>
                      <thead class="text-xs-left">
                        <th>Customer</th>
                        <th>Vehicle</th>
                        <th>Date</th>
                        <th>Engineer</th>
                        <th>Project</th>
                        <th>Job No</th>
                        <th>Status</th>
                        <th>Cost</th>
                      </thead>
                      <tbody>
                        <template v-for="job in invoicedJobs">
                          <tr :key="job.jobNo" v-if="job.invoiceNumber === props.item.invoiceNumber">
                            <td>{{ job.filteredCustomer}}</td>
                            <td>{{ job.Vehicle }}</td>
                            <td>{{ job.Date | formatDate}}</td>
                            <td>{{ job.filteredAllocated}}</td>
                            <td>{{ job.Project }}</td>
                            <td>{{ job.JobNo }}</td>
                            <td>{{ job.Status | jobStatus(job.filteredAllocated) }}</td>
                            <td>{{ job.currency || '£' }}{{ job.cost || 0 }}</td>
                            <td class="text-xs-right">
                              <v-btn v-if="job.Status > 1" icon class="mx-0" @click.stop="viewJob(job.id)">
                                <v-icon color="primary">assignment_turned_in</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </v-card>
                </v-layout>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item key="Jobs" v-if="supplier">
          <v-layout wrap>
            <v-flex v-for="(card, i) in summaryCards" :key="i">
              <v-card class="pa-2 ma-1 text-xs-center">
                <v-progress-circular :size="70" :width="10" :rotate="360" :value="states[i] / totalJobs * 100" :color="card.color">
                  {{states[i]}}
                </v-progress-circular>
                <div class="title">{{card.title}}</div>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card class="mt-2">
            <v-card-title>
              <v-btn icon flat color="primary" :to="'/Calendar/'+supplier">
                <v-icon>event</v-icon>
              </v-btn>
              <div style="max-width:440px;">
                <v-select label="Filter Invoice Status" :items="jobInvoiceStatuses" multiple v-model="jobInvoiceStatusFilter" chips deletable-chips/>
              </div>
              <v-spacer></v-spacer>
              <div style="max-width:440px;">
                <v-select label="Filter Job Status" :items="jobStatuses" multiple v-model="jobStatusFilter" chips deletable-chips/>
              </div>
              <v-spacer></v-spacer>
              <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="modifiedJobs" :search="search" v-model="selected" :pagination.sync="pagination" item-key="id" select-all :loading="tableLoading">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
                  </td>
                  <td @click.stop="props.expanded = !props.expanded">{{ props.item.filteredCustomer}}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{ props.item.Vehicle }}</td>
                  <!-- <td @click.stop="props.expanded = !props.expanded">{{ props.item.Date | formatDate }}</td> -->
                  <td @click.stop="props.expanded = props.item.Status >= 1 ? !props.expanded : props.expanded">
                    <v-edit-dialog
                      v-if="props.item.Status < 1"
                      :return-value.sync="updateDate"
                      lazy
                      large
                      persistent
                      @save="updateJob(props.item, true)"
                    >
                      <div style="border-bottom: 2px #106172 solid;">{{props.item.Date | formatDate}}</div>
                      <template v-slot:input>
                        <v-date-picker no-title :value="jobs[props.item.index].Date" @change="v => updateDate = v" scrollable style="box-shadow:none">
                        </v-date-picker>
                      </template>
                    </v-edit-dialog>
                    <div v-else>{{props.item.Date | formatDate}}</div>
                  </td>
                  <!-- <td @click.stop="props.expanded = !props.expanded">{{ props.item.filteredAllocated}}</td> -->
                  <td @click.stop="props.expanded = props.item.Status >= 1 ? !props.expanded : props.expanded">
                    <v-edit-dialog
                      v-if="props.item.Status < 1"
                      :return-value.sync="updateAllocated"
                      lazy
                      large
                      persistent
                      @save="updateJob(props.item, true)"
                    >
                      <div style="border-bottom: 2px #106172 solid;">{{props.item.filteredAllocated}}</div>
                      <template v-slot:input>
                        <v-select no-title :value="jobs[props.item.index].Allocated" @change="v => updateAllocated = v" :items="supplierSelectEngineers" item-text="name" item-value="key">
                        </v-select>
                      </template>
                    </v-edit-dialog>
                    <div v-else>{{props.item.filteredAllocated}}</div>
                  </td>
                  <td @click.stop="props.expanded = !props.expanded">{{ props.item.Project }}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{ props.item.JobNo }}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{ props.item.Status | jobStatus(props.item.filteredAllocated) }}</td>
                  <td>
                    <v-edit-dialog
                      v-if="props.item.invoiceStatusNumber == -2"
                      :return-value.sync="updateCurrency"
                      lazy
                      large
                      persistent
                      @save="updateJob(props.item, true)"
                    >
                      <div style="border-bottom: 2px #106172 solid;">{{ props.item.currency || '£' }}</div>
                      <template v-slot:input>
                        <v-select :value="jobs[props.item.index].currency || '£'" @change="v => updateCurrency = v" :items="['£', '€']"/>
                      </template>
                    </v-edit-dialog>
                    <div v-else>{{ props.item.currency || '£' }}</div>
                  </td>
                  <td>
                    <v-edit-dialog
                      v-if="props.item.invoiceStatusNumber == -2"
                      :return-value.sync="updateCost"
                      lazy
                      large
                      persistent
                      @save="updateJob(props.item, true)"
                    >
                      <div style="border-bottom: 2px #106172 solid;">{{ props.item.cost || 0 }}</div>
                      <template v-slot:input>
                        <v-text-field :value="jobs[props.item.index].cost || '0'" @change="v => updateCost = v" type="number"/>
                      </template>
                    </v-edit-dialog>
                    <div v-else>{{ props.item.cost || 0 }}</div>
                  </td>
                  <td @click.stop="props.expanded = !props.expanded">{{ props.item.invoiceStatus }}</td>
                  <td @click.stop="props.expanded = !props.expanded">{{ props.item.invoiceNumber }}</td>
                  <td class="text-xs-right">
                    <v-tooltip v-if="props.item.jobStarted && props.item.Status == 0" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon class="mx-0">
                          <v-icon color="blue">account_box</v-icon>
                        </v-btn>
                      </template>
                      <span>Engineer has started this job but not sent it back to portal yet</span>
                    </v-tooltip>
                    <v-btn v-if="props.item.Status > 0" icon class="mx-0" @click.stop="viewJob(props.item.id)">
                      <v-icon v-if="props.item.Status > 2" color="primary">assignment_turned_in</v-icon>
                      <v-icon v-else-if="props.item.Status == 2" color="success">assignment_ind</v-icon>
                      <v-icon v-else color="red">assignment_late</v-icon>
                    </v-btn>
                    <v-btn v-if="props.item.Status < 2" icon class="mx-0" @click.stop="completeJob(props.item.id)">
                      <v-icon color="green">check</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-layout justify-center>
                  <v-card class="ma-2">
                    <v-list dark dense>
                      <v-list-tile v-for="(template, i) in props.item.templates" v-bind:key="i">
                        <v-list-tile-action>
                          <v-checkbox disabled input-value="true"></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{templates.find(t => { return t.id === template }).name}}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-layout>
              </template>
            </v-data-table>
          </v-card>
          <completed-view :visible.sync="viewDialog" :JobID="currentJob"></completed-view>
        </v-tab-item>
      </v-tabs>
      
    <!-- Add to project dialog -->
    <v-dialog v-model="addToProjectDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          Assign Jobs to Project
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-select label="Assign to Project" :items="projects" v-model="assignToProject" item-text="projectId" item-value="projectId"></v-select>
            <h3>Jobs to be assigned</h3>
            <v-list dense v-if="selected">
              <v-list-tile v-for="(job, index) in selected" :key="index">
                {{job.JobNo}}
              </v-list-tile>
            </v-list>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="addJobsToProject" :loading="savingAddJobsToProject">Save</v-btn>
          <v-btn color="blue darken-1" right flat @click.native="addToProjectDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Assign to engineer dialog -->
    <v-dialog v-model="assignToEngineerDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Assign Jobs to Engineer</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-autocomplete label="Assign to Supplier" :items="suppliers" v-model="supplier" item-text="name" item-value="key" disabled></v-autocomplete>
            <v-autocomplete label="Assign to Engineer" :items="assignToSupplierEngineers" v-model="assignToEngineer" item-text="name" item-value="key" :loading="gettingEngineers" clearable :disabled="!supplier"></v-autocomplete>
            <h3>Jobs to be assigned</h3>
            <v-list dense v-if="selected">
              <v-list-tile v-for="(job, index) in selected" :key="index">
                {{job.JobNo}}
              </v-list-tile>
            </v-list>
            <h5 v-if="!supplier" class="error--text">A Supplier must be assigned to the selected jobs parent project</h5>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="assignJobsToEngineer" :loading="savingAssignJobsToEngineer" :disabled="!supplier">Save</v-btn>
          <v-btn color="blue darken-1" right flat @click.native="assignToEngineerDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- update cost dialog -->
    <v-dialog v-model="bulkUpdateCostDialog" max-width="500px" scrollable persistent>
      <v-card>
        <v-card-title>
          Update Cost
        </v-card-title>
        <v-card-text>
          <v-select label="Currency" :items="['£', '€']" v-model="bulkUpdateCurrency" />
          <v-text-field type="number" v-model="bulkUpdateCost" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" :loading="updatingCosts" flat @click.native="updateCosts">Update</v-btn>
          <v-btn color="blue darken-1" right flat @click.native="bulkUpdateCostDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- update invoice dialog -->
    <v-dialog v-model="invoiceStatusDialog" max-width="500px" scrollable>
      <v-card v-if="activeInvoice">
        <v-card-title>
          Invoice Status
        </v-card-title>
        <v-card-text>
          <h3>Invoice: {{activeInvoice.invoiceNumber}}</h3>
          <v-select label="Invoice Status" :items="invoiceStatuses" v-model="activeInvoice.status" />
          <v-textarea v-model="activeInvoice.note" label="Note"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" :loading="savingInvoice" flat @click.native="saveInvoice">Update</v-btn>
          <v-btn color="blue darken-1" right flat @click.native="invoiceStatusDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Complete job dialog -->
    <v-dialog v-model="completeDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Complete Job</span>
        </v-card-title>
        <v-card-text>
          <h4>You are about to complete job {{currentJobNo}}.</h4>
          <template v-if="jobs.find(job => {return job.id === this.currentJob})">
            <h5>Job Attachments</h5>
            <v-list-tile v-for="doc in jobs.find(job => {return job.id === this.currentJob}).completedDocs" :key="doc.name">
              <v-list-tile-avatar><v-icon>mdi-file-document-outline</v-icon></v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <a :href="doc.downloadUrl" target="_BLANK">{{doc.name}}</a>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <upload-btn uniqueId :title="'Attach New Document'" :fileChangedCallback="attachCompletedFile">
            <template slot="icon">
              <v-icon color="white">mdi-paperclip</v-icon>
            </template>
          </upload-btn>
          <v-progress-linear :color="fileProgress === 100 ? 'success' : 'primary'" :value="fileProgress"></v-progress-linear>
        </v-card-text>
        <v-card-actions v-if="jobs.find(job => {return job.id === this.currentJob})">
          <v-spacer></v-spacer>
          <v-btn color="green" flat @click.native="completeCurrentJob" :loading="completingJob" 
            :disabled="jobs.find(job => {return job.id === this.currentJob}).Status < 1 && !jobs.find(job => {return job.id === this.currentJob}).completedDocs"
          >
            Complete Job
          </v-btn>
          <v-btn color="blue darken-1" right flat @click.native="completeDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Create invoice dialog -->
    <v-dialog v-model="createInvoiceDialog" max-width="500px" scrollable persistent>
      <v-card>
        <v-card-title>
          <span>Add Invoice</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="createInvoiceDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <h3>You are about to add an invoice for the following jobs</h3>
          <table v-if="selected" style="text-align:left; width:100%;">
            <thead>
              <th>Job No</th>
              <th>Vehicle</th>
              <th>Cost</th>
            </thead>
            <tr v-for="(job, index) in selected" :key="index">
              <td>{{job.JobNo}}</td>
              <td>{{job.Vehicle}}</td>
              <td>
                <v-progress-circular v-if="job.saving" size="20" width="2" indeterminate color="primary"></v-progress-circular>
                <v-edit-dialog
                  :return-value.sync="updateCost"
                  lazy
                  large
                  persistent
                  @save="updateJob(job, false)"
                  v-else
                >
                  <div style="border-bottom: 2px #106172 solid;">{{job.currency || '£'}}{{job.cost || '-'}}</div>
                  <template v-slot:input>
                    <v-text-field :value="job.cost || '0'" @change="v => updateCost = v" type="number"/>
                  </template>
                </v-edit-dialog>
              </td>
            </tr>
            <tfoot>
              <th></th>
              <th>Total</th>
              <th>{{selected[0] && selected[0].currency ? selected[0].currency : '£'}}{{totalSelectedCost}}</th>
            </tfoot>
          </table>
          <p>Before uploading your invoice please check the total cost matches above.</p>
          <v-text-field outline label="Invoice Number" v-model="invoiceNumber"/>
          <upload-btn :disabled="!invoiceNumber" uniqueId :title="'Upload Invoice'" :fileChangedCallback="uploadInvoice">
            <template slot="icon">
              <v-icon color="white">mdi-file-document</v-icon>
            </template>
          </upload-btn>
          <v-progress-linear :color="fileProgress === 100 ? 'success' : 'primary'" :value="fileProgress"></v-progress-linear>          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="red darken-1" flat @click.native="deleteMultiJobs" :loading="deletingJobs">Delete Jobs</v-btn>
          <v-btn color="blue darken-1" right flat @click.native="deleteJobsDialog = false">Cancel</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-fab-transition>
      <v-speed-dial v-model="fab" v-show="selected.length > 0" bottom right fixed>
        <v-btn slot="activator" color="primary" dark fab hover v-model="fab">
          <v-icon>edit</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
        <v-tooltip :disabled="tooltipsDisabled" left :value="tooltips" color="cyan">
          <v-btn slot="activator" fab dark small color="cyan" @click="assignToEngineerDialog = true">
            <v-icon>assignment_ind</v-icon>
          </v-btn>
          <span>Assign Engineer</span>
        </v-tooltip>
        <v-tooltip v-if="allNotInvoiced" :disabled="tooltipsDisabled" left :value="tooltips" color="purple">
          <v-btn slot="activator" fab dark small color="purple" @click="bulkUpdateCostDialog = true">
            £
          </v-btn>
          <span>Add Cost</span>
        </v-tooltip>
        <v-tooltip v-if="allNotInvoiced" :disabled="tooltipsDisabled" left :value="tooltips" color="success">
          <v-btn slot="activator" fab dark small color="success" @click="createInvoiceDialog = true">
            <v-icon>mdi-file-document</v-icon>
          </v-btn>
          <span>Add Invoice</span>
        </v-tooltip>
      </v-speed-dial>
    </v-fab-transition>
  </v-container>
</template>
<script>
import { fireStore, storage, updateAuditLog } from '../firebase'
import moment from 'moment'
import UploadButton from 'vuetify-upload-button'
export default {
  components: {
    'upload-btn': UploadButton
  },
  props: ['supplier'],
  data () {
    return {
      updatingCosts: false,
      bulkUpdateCost: 0,
      bulkUpdateCurrency: '£',
      updateCost: null,
      updateCurrency: null,
      updateAllocated: null,
      bulkUpdateCostDialog: false,
      completeDialog: false,
      completingJob: false,
      updateDate: null,
      activeTab: +localStorage.getItem('supplier-active-tab') || 0,
      fab: false,
      selected: [],
      selectedProject: [],
      oldExtras: false,
      createInvoiceDialog: false,
      tooltips: false,
      tooltipsDisabled: false,
      invoiceNumber: '',
      activeInvoice: null,
      invoiceStatusDialog: false,
      summaryCards: [
        {title: 'Not Started', color: 'grey'},
        {title: 'Awaiting Install', color: 'orange'},
        {title: 'Issue', color: 'red'},
        {title: 'Complete', color: 'cyan'},
        {title: 'Complete - Cubo Approved', color: 'green'}
      ],
      projectSummaryCards: [
        {title: 'Awaiting Approval', color: 'grey'},
        {title: 'CTN Sheet Approved', color: 'cyan'},
        {title: 'Cancelled', color: 'red'},
        {title: 'In Progress', color: 'orange'},
        {title: 'Complete', color: 'green'}
      ],
      addToProjectDialog: false,
      expanded: false,
      newJobValid: false,
      supplierSelect: '',
      viewDialog: false,
      managerList: [],
      currentJob: '',
      gettingEngineers: false,
      gettingVehicles: false,
      dateMenu: false,
      date: moment().format('YYYY-MM-DD'),
      projectDateDialog: false,
      jobs: [],
      tableLoading: false,
      projectTableLoading: false,
      savingInvoice: false,
      jobStatusFilter: [],
      invoiceStatusFilter: [],
      jobInvoiceStatusFilter: [],
      invoiceStatuses: [
        {
          text: 'Invoice Not Actioned',
          value: 0
        },
        {
          text: 'In Query',
          value: 1
        },
        {
          text: 'Approved',
          value: 2
        },
        {
          text: 'Paid',
          value: 3
        },
        {
          text: 'Rejected',
          value: -1
        }
      ],
      jobStatuses: [
        {text: 'Not Started', value: 5},
        {text: 'Awaiting Install', value: 4},
        {text: 'Issue', value: 1},
        {text: 'Complete', value: 2},
        {text: 'Complete - Cubo Approved', value: 3}
      ],
      invoiceHeaders: [
        {
          text: 'Supplier',
          value: 'supplierText',
          align: 'left'
        },
        {
          text: 'Invoice No',
          value: 'invoiceNumber',
          align: 'left'
        },
        {
          text: 'Submitted',
          value: 'submittedDate',
          align: 'left'
        },
        {
          text: 'Last Actioned',
          value: 'lastActioned',
          align: 'left'
        },
        {
          text: 'Last User',
          value: 'lastUser',
          align: 'left'
        },
        {
          text: 'Last Note',
          value: 'lastNote',
          align: 'left'
        },
        {
          text: 'Cost',
          value: 'cost',
          align: 'left'
        },
        {
          text: 'Status',
          value: 'statusText',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'status',
          align: 'right'
        }
      ],
      headers: [
        {
          text: 'Customer',
          value: 'Customer',
          align: 'left'
        },
        {
          text: 'Vehicle',
          value: 'vehReg',
          align: 'left'
        },
        {
          text: 'Date',
          value: 'Date',
          align: 'left'
        },
        {
          text: 'Engineer',
          value: 'Allocated',
          align: 'left'
        },
        {
          text: 'Project',
          value: 'Project',
          align: 'left'
        },
        {
          text: 'Job Number',
          value: 'JobNo',
          align: 'left'
        },
        {
          text: 'Status',
          value: 'Status',
          align: 'left'
        },
        {
          text: '£/€',
          value: 'currency',
          align: 'left'
        },
        {
          text: 'Cost',
          value: 'cost',
          align: 'left'
        },
        {
          text: 'Invoice Status',
          value: 'invoiceStatus',
          align: 'left'
        },
        {
          text: 'Invoice Number',
          value: 'invoiceNumber',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right',
          sortable: false
        }
      ],
      projectHeaders: [
        {
          text: 'Project ID',
          value: 'projectId',
          align: 'left'
        },
        {
          text: 'Date',
          value: 'Date',
          align: 'left'
        },
        {
          text: 'Project Status',
          value: 'Status',
          align: 'left'
        },
        {
          text: 'Project Manager(s)',
          value: 'manager',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right',
          sortable: false
        }
      ],
      projectHeadersSupplier: [
        {
          text: 'Project ID',
          value: 'projectId',
          align: 'left'
        },
        {
          text: 'Date',
          value: 'Date',
          align: 'left'
        },
        {
          text: 'Project Status',
          value: 'Status',
          align: 'left'
        },
        {
          text: 'Project Manager(s)',
          value: 'manager',
          align: 'left'
        }
      ],
      search: '',
      searchInvoices: '',
      dialog: false,
      editedIndex: -1,
      engineers: [],
      fileProgress: 0,
      vehicles: [],
      selectProducts: ['preCheck'],
      editedItem: {
        vehReg: '',
        JobNo: null,
        templates: ['preCheck'],
        templateExtras: [],
        Supplier: this.supplier,
        Allocated: '',
        Date: null,
        Status: 0,
        additionalFields: [],
        extras: {}
      },
      vehicleSelect: '',
      defaultItem: {
        vehReg: '',
        JobNo: null,
        templates: ['preCheck'],
        templateExtras: [],
        Supplier: this.supplier,
        Allocated: '',
        Date: null,
        Status: 0,
        additionalFields: [],
        extras: {}
      },
      states: [],
      projectStates: [],
      sites: [],
      totalJobs: 0,
      totalProjects: 0,
      customerSelect: '',
      templateExtras: [],
      editedProjectIndex: -1,
      projectDialog: false,
      newProjectValid: false,
      editedProject: {
        id: '',
        totalJobs: 0,
        completedJobs: 0,
        Status: 0,
        manager: '',
        Date: null,
        BDM: '',
        customerTicket: '',
        engineerTicket: '',
        BDMTicket: '',
        financeCustomer: 0,
        financeInvoiced: null,
        financeSupplier: 0,
        supplierPaid: null,
        customerPO: null,
        customerCost: null,
        jobType: null
      },
      defaultProject: {
        id: '',
        totalJobs: 0,
        completedJobs: 0,
        Status: 0,
        manager: '',
        Date: null,
        BDM: '',
        customerTicket: '',
        engineerTicket: '',
        BDMTicket: '',
        financeCustomer: 0,
        financeInvoiced: null,
        financeSupplier: 0,
        supplierPaid: null,
        customerPO: null,
        customerCost: null,
        jobType: null
      },
      projects: [],
      gettingNewProjectId: false,
      newProject: false,
      deleteProjectDialog: false,
      deleteProjectData: {},
      assignToProject: null,
      assignToEngineerDialog: false,
      assignToEngineer: '',
      assignToEngineerDate: null,
      assignToEngineerDateDialog: false,
      assignToSupplier: '',
      savingAddJobsToProject: false,
      savingAssignJobsToEngineer: false,
      savingSaveProject: false,
      savingSaveJob: false,
      projectStatusFilter: null,
      pagination: {
        sortBy: 'Project',
        rowsPerPage: 25,
        page: 1,
        descending: true
      },
      projectsPagination: {
        sortBy: 'projectId',
        rowsPerPage: 25,
        page: 1,
        descending: true
      },
      invoiceNumberFilter: null
    }
  },
  created () {
    this.$store.dispatch('fetchSuppliers')
    if (this.role === 'Supplier' && this.supplier !== this.$store.getters.userData.Company) {
      this.$router.push('/Supplier/' + this.$store.getters.userData.Company)
    }
    if (this.supplier) {
      this.supplierSelect = this.supplier
    }
    this.$store.dispatch('fetchCustomers')
    this.$store.dispatch('fetchDeviceTypes')
    this.$store.dispatch('fetchProductTypes')
    this.$store.dispatch('fetchDevices')
    this.getEngineers()
    this.getJobs()
    this.getProjects()
    this.getVehicles()
  },
  mounted () {
    this.defaultProject.Date = moment().format('YYYY-MM-DD')
    this.editedProject.Date = moment().format('YYYY-MM-DD')
    this.$store.dispatch('fetchInvoices')
    // this.projectDateDialog = moment().format('YYYY-MM-DD')
  },
  computed: {
    currentJobNo () {
      if (this.currentJob) {
        const index = this.jobs.findIndex(job => {
          return this.currentJob === job.id
        })
        if (index > -1) {
          return this.jobs[index]['JobNo']
        } else {
          return null
        }
      } else {
        return null
      }
    },
    jobInvoiceStatuses () {
      let statuses = JSON.parse(JSON.stringify(this.invoiceStatuses))
      statuses.unshift({value: -2, text: 'Not Invoiced'})
      return statuses
    },
    allNotInvoiced () {
      let invoiceMinStatus = this.$store.getters.userData.minInvoiceStatus || 2
      for (let item of this.selected) {
        if (item.invoiceStatus !== 'Not Invoiced' || item.Status < invoiceMinStatus) {
          return false
        }
      }
      return true
    },
    totalSelectedCost () {
      let total = 0
      for (let job of this.selected) {
        if (job.cost) {
          total += +job.cost
        }
      }
      return total
    },
    customerList () {
      return this.$store.getters.customers
    },
    templates () {
      return this.$store.getters.deviceTypes
    },
    products () {
      return this.$store.getters.productTypes
    },
    devices () {
      return this.$store.getters.devices
    },
    invoices () {
      return this.$store.getters.invoices
    },
    userData () {
      return this.$store.getters.userData
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Job' : 'Edit Job'
    },
    projectFormTitle () {
      return this.editedProjectIndex === -1 ? 'New Project' : 'Edit Project'
    },
    customerObj () {
      let obj = {}
      this.customerList.forEach(customer => {
        obj[customer.key] = customer.name
      })
      return obj
    },
    suppliers () {
      return this.$store.getters.suppliers.sort((a, b) => {
        const aName = a.name.toLowerCase()
        const bName = b.name.toLowerCase()
        return aName < bName ? -1 : aName > bName ? 1 : 0
      })
    },
    role () {
      return this.$store.getters.userData.Role
    },
    supplierSelectEngineers () {
      let arr = []
      this.engineers.forEach(engineer => {
        if (engineer.supplier === this.supplierSelect) {
          arr.push(engineer)
        }
      })
      return arr
    },
    engineerObj () {
      let engineerObj = {}
      this.engineers.forEach(engineer => {
        engineerObj[engineer.key] = engineer
      })
      return engineerObj
    },
    modifiedInvoices () {
      let modifiedInvoices = []
      let invoices = JSON.parse(JSON.stringify(this.invoices))

      for (let invoice of invoices) {
        if (this.supplier && this.supplier !== invoice.supplier) {
          continue
        }

        if (this.invoiceStatusFilter.length && this.invoiceStatusFilter.indexOf(invoice.status) === -1) {
          continue
        }

        switch (invoice.status) {
          case 0:
            invoice.statusText = 'Invoice Submitted'
            break
          case -1:
            invoice.statusText = 'Invoice Rejected'
            break
          case 1:
            invoice.statusText = 'Invoice In Query'
            break
          case 2:
            invoice.statusText = 'Invoice Approved'
            break
          case 3:
            invoice.statusText = 'Invoice Paid'
            break
        }

        invoice.supplierText = this.suppliers.find((s) => { return s.key === invoice.supplier })
        invoice.supplierText = invoice.supplierText ? invoice.supplierText.name : ''

        modifiedInvoices.push(invoice)
      }

      return modifiedInvoices
    },
    modifiedJobs () {
      let modifiedJobs = []
      let jobs = JSON.parse(JSON.stringify(this.jobs))
      jobs.forEach((job, i) => {
        let addJob = false
        if (this.jobStatusFilter.length < 1) {
          addJob = true
        } else if (this.jobStatusFilter.indexOf(3) !== -1 && job.Status === 3) {
          addJob = true
        } else if (this.jobStatusFilter.indexOf(2) !== -1 && job.Status === 2) {
          addJob = true
        } else if (this.jobStatusFilter.indexOf(1) !== -1 && job.Status === 1) {
          addJob = true
        } else if (this.jobStatusFilter.indexOf(4) !== -1 && job.Allocated && (!job.Status || job.Status < 1)) {
          addJob = true
        } else if (this.jobStatusFilter.indexOf(5) !== -1 && !job.Allocated && (!job.Status || job.Status < 1)) {
          addJob = true
        } else {
          addJob = false
        }

        if (!addJob) {
          return
        }
        const projectObj = this.projects.find(project => {
          return project.projectId === job.Project
        })
        if (!projectObj || projectObj.Supplier !== this.supplier) {
          return
        }
        if (this.customerObj[job.Customer] !== undefined) {
          job.filteredCustomer = this.customerObj[job.Customer]
        } else {
          job.filteredCustomer = '----'
        }
        if (this.engineerObj[job.Allocated] !== undefined) {
          job.filteredAllocated = this.engineerObj[job.Allocated].name
        } else {
          job.filteredAllocated = '----'
        }
        job.index = i
        job.invoiceNumber = ''
        job.invoiceStatusNumber = -2
        if (this.invoices.length) {
          for (let invoice of this.invoices) {
            if (invoice.jobs.indexOf(job.JobNo) !== -1) {
              job.invoiceNumber = invoice.invoiceNumber
              job.invoiceStatusNumber = invoice.status
              switch (invoice.status) {
                case 0:
                  job.invoiceStatus = 'Invoiced'
                  break
                case -1:
                  job.invoiceStatus = 'Invoice Rejected'
                  break
                case 1:
                  job.invoiceStatus = 'Invoice In Query'
                  break
                case 2:
                  job.invoiceStatus = 'Invoice Approved'
                  break
                case 3:
                  job.invoiceStatus = 'Invoice Paid'
                  break
              }
              break
            }
            job.invoiceStatus = 'Not Invoiced'
          }
        } else {
          job.invoiceStatus = 'Not Invoiced'
        }

        if (this.jobInvoiceStatusFilter.length && this.jobInvoiceStatusFilter.indexOf(job.invoiceStatusNumber) === -1) {
          return
        }

        if (job.Vehicle) {
          const index = this.vehicles.findIndex(vehicle => {
            return vehicle.key === job.Vehicle
          })
          if (index > -1) {
            if (this.vehicles[index]['VehicleReg'] && this.vehicles[index]['VehicleReg'].length > 0) {
              job.Vehicle = this.vehicles[index]['VehicleReg']
            } else {
              job.Vehicle = this.vehicles[index]['friendlyId']
            }
            job.VehicleYear = this.vehicles[index]['Year']
            job.VehicleMake = this.vehicles[index]['Make']
            job.VehicleModel = this.vehicles[index]['Model']
            job.VehicleSite = this.vehicles[index]['Site']
          } else {
            job.Vehicle = ''
          }
        } else {
          job.Vehicle = job.vehReg
        }

        modifiedJobs.push(job)
      })
      return modifiedJobs
    },
    invoicedJobs () {
      let invoicedJobs = []
      let jobs = JSON.parse(JSON.stringify(this.jobs))
      jobs.forEach((job, i) => {
        job.index = i
        job.invoiceNumber = ''
        for (let invoice of this.invoices) {
          if (invoice.jobs.indexOf(job.JobNo) !== -1) {
            console.log(invoice.invoiceNumber)
            job.invoiceNumber = invoice.invoiceNumber
            switch (invoice.status) {
              case 0:
                job.invoiceStatus = 'Invoiced ' + (job.currency || '£') + (job.cost || 0)
                break
              case -1:
                job.invoiceStatus = 'Invoice Rejected'
                break
              case 1:
                job.invoiceStatus = 'Invoice In Query'
                break
              case 2:
                job.invoiceStatus = 'Invoice Approved'
                break
              case 3:
                job.invoiceStatus = 'Invoice Paid'
                break
            }
            break
          }
        }

        if (!job.invoiceStatus) {
          return
        }

        if (this.customerObj[job.Customer] !== undefined) {
          job.filteredCustomer = this.customerObj[job.Customer]
        } else {
          job.filteredCustomer = '----'
        }
        if (this.engineerObj[job.Allocated] !== undefined) {
          job.filteredAllocated = this.engineerObj[job.Allocated].name
        } else {
          job.filteredAllocated = '----'
        }

        if (job.Vehicle) {
          const index = this.vehicles.findIndex(vehicle => {
            return vehicle.key === job.Vehicle
          })
          if (index > -1) {
            if (this.vehicles[index]['VehicleReg'] && this.vehicles[index]['VehicleReg'].length > 0) {
              job.Vehicle = this.vehicles[index]['VehicleReg']
            } else {
              job.Vehicle = this.vehicles[index]['friendlyId']
            }
            job.VehicleYear = this.vehicles[index]['Year']
            job.VehicleMake = this.vehicles[index]['Make']
            job.VehicleModel = this.vehicles[index]['Model']
            job.VehicleSite = this.vehicles[index]['Site']
          } else {
            job.Vehicle = ''
          }
        } else {
          job.Vehicle = job.vehReg
        }

        invoicedJobs.push(job)
      })
      return invoicedJobs
    },
    filteredProjects () {
      return this.projects.filter((i) => {
        if (!this.projectStatusFilter) {
          return true
        } else if (this.projectStatusFilter === 'In Progress' && i.Status === 'In Progress') {
          return true
        } else if (this.projectStatusFilter === 'Complete' && i.Status === 'Complete') {
          return true
        } else if (this.projectStatusFilter === 'Cancelled' && i.Status === 'Cancelled') {
          return true
        } else if (this.projectStatusFilter === 'CTN Sheet Approved' && i.Status === 'CTN Sheet Approved') {
          return true
        } else if (this.projectStatusFilter === 'Awaiting Approval' && (i.Status === undefined || i.Status === null)) {
          return true
        } else {
          return false
        }
      })
    },
    customerVehicles () {
      const customer = this.customerSelect
      let vehicles = []
      if (customer) {
        this.vehicles.forEach(vehicle => {
          if (vehicle.Customer === customer) {
            vehicles.push(vehicle)
          }
        })
      }
      return vehicles
    },
    assignToSupplierEngineers () {
      let arr = []
      this.engineers.forEach(engineer => {
        if (engineer.supplier === this.supplier) {
          arr.push(engineer)
        }
      })
      return arr
    }
  },
  watch: {
    activeTab (val) {
      localStorage.setItem('supplier-active-tab', val)
    },
    fab (val) {
      this.tooltips = false
      this.tooltipsDisabled = false
      val && setTimeout(() => {
        this.tooltips = true
        this.$nextTick(() => {
          this.tooltipsDisabled = true
        })
      }, 250)
    },
    selected (val) {
      this.tooltips = false
      this.tooltipsDisabled = false
      val.length && setTimeout(() => {
        this.tooltips = true
        this.$nextTick(() => {
          this.tooltipsDisabled = true
        })
      }, 250)
    },
    vehicleSelect: function (val) {
      if (val === null) {
        val = ''
      }
      if (typeof val === 'string') {
        this.editedItem.vehReg = val
      } else {
        this.editedItem.vehReg = val.VehicleReg
      }
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.VehicleReg === this.editedItem.vehReg
      })
      if (index > -1) {
        this.editedItem.Vehicle = this.vehicles[index]['key']
      } else {
        this.editedItem.Vehicle = null
      }
    },
    selectProducts: function (val) {
      this.editedItem.products = val
      let productExtras = []
      let productExtraKeys = []
      // let keysToDelete = []
      this.editedItem.templateExtras = []

      const allProducts = this.products
      const products = this.editedItem.products
      if (products) {
        products.forEach((v) => {
          // Stores the extras which match the currently selected products in the data model. Can then be queried to make sure we only show the correct extras in the form etc.
          const arrayId = allProducts.findIndex((obj) => {
            return obj.id === v
          })
          if (allProducts[arrayId] !== undefined && allProducts[arrayId]['extras'] !== undefined && allProducts[arrayId]['extras'] !== null && allProducts[arrayId]['extras'] !== '') {
            allProducts[arrayId]['extras'].forEach((extra) => {
              extra['id'] = allProducts[arrayId]['id']
              productExtras.push(extra)
              productExtraKeys.push(extra.name)
            })
          }

          let templateDetails = []
          if (allProducts[arrayId] && allProducts[arrayId].devices) {
            for (let template of allProducts[arrayId].devices) {
              let device = this.templates.find(t => { return template === t.id })
              device.deviceDetails = this.devices.find(d => { return d.type === device.id && d.vehicle === this.editedItem.Vehicle })
              templateDetails.push(device)
            }
            this.editedItem.templateExtras.push({
              product: allProducts[arrayId],
              templateDetails: templateDetails
            })
          }
        })
        // for (let key in this.editedItem.extras) {
        //   // Store names of extras which need to be deleted
        //   if (!productExtraKeys.includes(key)) {
        //     keysToDelete.push(key)
        //   }
        // }
        // keysToDelete.forEach((keyName) => {
        //   delete this.editedItem.extras[keyName]
        // })
        for (let key in productExtraKeys) {
          // IF value of extras hasn't been set, set the value to the default found in db
          let obj = {}
          if (this.editedItem.extras !== undefined) {
            if (!this.editedItem.extras.hasOwnProperty(productExtraKeys[key])) {
              var index = productExtras.findIndex(obj => {
                return obj.name === productExtraKeys[key]
              })
              if (index === -1) {
                obj[productExtraKeys[key]] = ''
              } else {
                obj[productExtraKeys[key]] = productExtras[key]['default']
              }
              Object.assign(this.editedItem.extras, obj)
            }
          } else {
            // this.editedItem.extras = {}
            obj[productExtraKeys[key]] = ''
            Object.assign(this.editedItem.extras, obj)
          }
          if (products.indexOf('IGVjrrgemWhH8zki8yBZ') > -1) {
            const vehicleObj = this.vehicles.find(vehicle => { return vehicle.key === this.editedItem.Vehicle })
            this.editedItem.extras['[Tacho Smart] VU Part Number'] = (vehicleObj && vehicleObj.VUPartNo ? vehicleObj.VUPartNo : '')
          }
        }

        this.editedItem.productExtras = productExtraKeys
        this.productExtras = productExtras
        // this.editedItem.extras = this.editedItem.extras
      }
    },
    dialog (val) {
      val || this.close()
    },
    supplier: function (val) {
      if (this.role === 'Supplier' && this.supplier !== this.$store.getters.userData.Company) {
        this.$router.push('/Supplier/' + this.$store.getters.userData.Company)
      }
      this.getEngineers()
      this.getProjects()
      this.getJobs()
    },
    supplierSelect: function () {
      this.changeSupplier()
    },
    customerSelect: function (val) {
      this.editedItem.Customer = val
      this.sites = []
      if (this.editedIndex === -1) {
        this.vehicleSelect = ''
      }
      fireStore.collection('Sites').where('Customer', '==', val)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.sites.push({key: doc.id, name: doc.data().Name})
        })
      })
    }
  },
  filters: {
    invoiceStatus (val) {
      switch (val) {
        case 0:
          return 'Invoice Submitted'
        case -1:
          return 'Invoice Rejected'
        case 1:
          return 'Invoice In Query'
        case 2:
          return 'Invoice Approved'
        case 3:
          return 'Invoice Paid'
      }
    },
    formatDate (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY') : null
    },
    arrayToString (val) {
      let str = ''
      if (val) {
        val.forEach(arrayVal => {
          str += arrayVal + ', '
        })
        str = str.substr(0, str.length - 2)
      }
      return str
    },
    jobStatus (Status, Allocated) {
      if (Status === 3) {
        return 'Complete - Cubo Approved'
      } else if (Status === 2) {
        return 'Complete'
      } else if (Status === 1) {
        return 'Issue'
      } else {
        if (Allocated === '' || Allocated === null || Allocated === undefined) {
          return 'Not Started'
        } else {
          return 'Awaiting Install'
        }
      }
    }
  },
  methods: {
    updateCosts () {
      this.updatingCosts = true
      let batch = fireStore.batch()
      for (let job of this.selected) {
        const jobRef = fireStore.collection('Jobs').doc(job.id)
        batch.update(jobRef, {cost: this.bulkUpdateCost, currency: this.bulkUpdateCurrency})
        updateAuditLog('update', 'supplier', this.userData, job.JobNo, job.Project, 'updated jobs engineer costs', {cost: this.bulkUpdateCost, currency: this.bulkUpdateCurrency}, job.Customer)
      }
      batch.commit()
      .then(() => {
        this.updatingCosts = false
        this.bulkUpdateCostDialog = false
        this.getJobs()
      })
      .catch(() => {
        this.updatingCosts = false
      })
    },
    completeJob (job) {
      this.currentJob = job
      this.completeDialog = true
    },
    completeCurrentJob () {
      this.completingJob = true
      const index = this.jobs.findIndex(job => {
        return job.id === this.currentJob
      })
      let completedDate = moment().format('YYYY-MM-DD')
      const jobRef = fireStore.collection('Jobs').doc(this.currentJob)
      jobRef.update({Status: 2, CompletedDate: completedDate})
      .then(() => {
        this.jobs[index].CompletedDate = completedDate
        this.jobs[index].Status = 2
        this.completingJob = false
        this.completeDialog = false
        updateAuditLog('update', 'supplier', this.userData, this.jobs[index].JobNo, this.jobs[index].Project, 'complete job', null, this.jobs[index].Customer)
      })
      .catch(() => {
        this.completingJob = false
      })
    },
    attachCompletedFile (f) {
      let promises = []
      let downloadUrls = []
      let fileObj = {Progress: 0, State: 0, file: f}
      const storageRef = storage.ref('CompletedDocs/' + this.currentJob)
      promises.push(new Promise((resolve, reject) => {
        let uploadTask = storageRef.child(fileObj.file.name).put(fileObj.file)
        uploadTask.on('state_changed', snapshot => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          fileObj['Progress'] = progress
          this.fileProgress = progress
        }, error => {
          // Handle unsuccessful uploads
          fileObj['State'] = 4
          reject(error)
        }, () => {
          // Handle successful uploads on complete
          fileObj['Progress'] = 100
          this.fileProgress = 100
          fileObj['State'] = 3
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            downloadUrls.push({downloadUrl: downloadURL, name: fileObj.file.name})
            resolve()
          })
        })
      }))
      Promise.all(promises).then(val => {
        const index = this.jobs.findIndex(job => {
          return job.id === this.currentJob
        })
        console.log(index)
        if (!this.jobs[index].completedDocs) {
          this.jobs[index].completedDocs = []
        }
        this.jobs[index].completedDocs.push(downloadUrls[0])
        fireStore.collection('Jobs').doc(this.currentJob)
        .update({
          completedDocs: this.jobs[index].completedDocs
        })
        updateAuditLog('update', 'supplier', this.userData, this.jobs[index].JobNo, this.jobs[index].Project, 'attached completed document', null, this.jobs[index].Customer)
        this.$forceUpdate()
      }).catch(error => {
        console.log(error)
      })
    },
    saveInvoice () {
      this.savingInvoice = true
      let invoice = this.activeInvoice
      let history = invoice.history || []
      history.unshift({
        note: invoice.note || '',
        status: invoice.status,
        date: moment().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.userData.Name
      })
      fireStore.collection('Invoices').doc(invoice.id).update({
        lastNote: invoice.note || '',
        status: invoice.status,
        lastActioned: moment().format('YYYY-MM-DD HH:mm'),
        lastUser: this.$store.getters.userData.Name,
        history: history
      }).then(() => {
        updateAuditLog('update', 'supplier', this.userData, null, null, 'Saved Invoice', invoice.invoiceNumber, null)
        setTimeout(() => {
          this.savingInvoice = false
          this.invoiceStatusDialog = false
        }, 2000)
      })
    },
    openInvoiceStatus (invoice) {
      this.activeInvoice = JSON.parse(JSON.stringify(invoice))
      this.invoiceStatusDialog = true
    },
    updateJob (job, deselect) {
      job.saving = true
      fireStore.collection('Jobs').doc(job.id).update({
        Date: this.updateDate ? this.updateDate : job.Date || null,
        Allocated: this.updateAllocated ? this.updateAllocated : job.Allocated || null,
        cost: this.updateCost ? this.updateCost : job.cost || null,
        currency: this.updateCurrency ? this.updateCurrency : job.currency || null
      })
      .then(() => {
        updateAuditLog('update', 'supplier', this.userData, job.JobNo, null, 'Updated Job Details', null, null)
        let selectedIndex = this.selected.findIndex(j => j.index === job.index)
        this.jobs[job.index].cost = this.updateCost ? this.updateCost : job.cost || null
        this.jobs[job.index].currency = this.updateCurrency ? this.updateCurrency : job.currency || null
        this.jobs[job.index].Allocated = this.updateAllocated ? this.updateAllocated : job.Allocated || null
        this.jobs[job.index].Date = this.updateDate ? this.updateDate : job.Date || null
        if (selectedIndex !== -1) {
          this.selected[selectedIndex].cost = this.updateCost ? this.updateCost : job.cost || null
          this.selected[selectedIndex].currency = this.updateCurrency ? this.updateCurrency : job.currency || null
          this.selected[selectedIndex].Allocated = this.updateAllocated ? this.updateAllocated : job.Allocated || null
          this.selected[selectedIndex].Date = this.updateDate ? this.updateDate : job.Date || null
        }
        this.updateCost = null
        this.updateCurrency = null
        this.updateDate = null
        this.updateAllocated = null
        job.saving = false
        this.$forceUpdate()
      })
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.key === id
      })
      if (index > -1) {
        if (this.vehicles[index]['VehicleReg'] && this.vehicles[index]['VehicleReg'].length > 0) {
          return this.vehicles[index]['VehicleReg']
        } else if (this.vehicles[index]['friendlyId']) {
          return this.vehicles[index]['friendlyId']
        } else {
          return id
        }
      } else {
        return id
      }
    },
    setProjectStates () {
      this.totalProjects = 0
      this.projectStates = [0, 0, 0, 0, 0]
      this.projects.forEach((data) => {
        if (data.Status === 'CTN Sheet Approved') {
          this.projectStates[1]++
        } else if (data.Status === 'In Progress') {
          this.projectStates[3]++
        } else if (data.Status === 'Complete') {
          this.projectStates[4]++
        } else if (data.Status === 'Cancelled') {
          this.projectStates[2]++
        } else {
          this.projectStates[0]++
        }
        this.totalProjects++
      })
    },
    setJobStates () {
      this.totalJobs = 0
      this.states = [0, 0, 0, 0, 0]
      this.jobs.forEach((data) => {
        if (data.Status === 3) {
          this.states[4]++
        } else if (data.Status === 2) {
          this.states[3]++
        } else if (data.Status === 1) {
          this.states[2]++
        } else {
          if (data.Allocated === '' || data.Allocated === null || data.Allocated === undefined) {
            this.states[0]++
          } else {
            this.states[1]++
          }
        }
        this.totalJobs++
      })
    },
    getProjects () {
      this.projectTableLoading = true
      this.projects = []
      if (this.supplier !== undefined) {
        fireStore.collection('Projects').where('Supplier', '==', this.supplier)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            data.id = doc.id
            this.projects.push(data)
            this.setProjectStates()
          })
          this.projectTableLoading = false
        })
      }
    },
    getJobs () {
      this.tableLoading = true
      this.jobs = []
      if (this.supplier !== undefined) {
        fireStore.collection('Jobs').where('Supplier', '==', this.supplier)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            data.id = doc.id
            data.cost = data.cost || null
            data.currency = data.currency || null
            data.Allocated = data.Allocated || null
            data.Date = data.Date || null
            this.jobs.push(data)
          })
          this.tableLoading = false
          this.setJobStates()
        })
      }
    },
    getInvoices () {
      this.invoices = []
      if (this.supplier) {
        fireStore.collection('Invoices').where('supplier', '==', this.supplier)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            data.id = doc.id
            this.invoices.push(data)
          })
        })
      }
    },
    getEngineers () {
      this.engineers = []
      fireStore.collection('Users').where('Role', 'in', ['Engineer', 'Supplier', 'Support and Engineer', 'Admin and Engineer'])
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.engineers.push({key: doc.data().UID, name: doc.data().Name, supplier: doc.data().Company})
        })
      })
    },
    getVehicles () {
      this.gettingVehicles = true
      this.vehicles = []
      fireStore.collection('Vehicles')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          if (!data.VehicleReg) {
            data.VehicleReg = data.friendlyId
          }
          this.vehicles.push({...data, key: doc.id})
          // const data = doc.data()
          // this.vehicles.push({key: doc.id, VehicleReg: data.VehicleReg ? data.VehicleReg : data.friendlyId, Customer: data.Customer, friendlyId: data.friendlyId})
        })
        this.gettingVehicles = false
      })
      .catch(() => {
        this.gettingVehicles = false
      })
    },
    viewJob (job) {
      this.currentJob = job
      this.viewDialog = true
    },
    editItem (item) {
      this.editedIndex = this.jobs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      let customerKey = ''
      let engineerKey = ''
      const vm = this
      Object.keys(vm.customerObj).forEach(function eachKey (key) {
        if (vm.customerObj[key] === vm.editedItem.Customer) {
          customerKey = key
        }
      })
      Object.keys(vm.engineers).forEach(function eachKey (key) {
        if (vm.engineers[key]['name'] === vm.editedItem.Allocated) {
          engineerKey = vm.engineers[key]['key']
        }
      })
      this.editedItem.Allocated = engineerKey
      this.customerSelect = customerKey
      if (this.editedItem.Vehicle) {
        this.vehicleSelect = this.vehicleRegFromID(this.editedItem.Vehicle)
      } else {
        this.vehicleSelect = this.editedItem.vehReg
      }
      this.selectProducts = this.editedItem.templates
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.jobs.indexOf(item)
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Jobs').doc(item.id).delete().then(() => {
        this.jobs.splice(index, 1)
        this.setJobStates()
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.templateExtras = []
        this.selectProducts = ['preCheck']
        this.vehicleSelect = ''
        this.customerSelect = ''
      }, 300)
    },
    changeSupplier () {
      if (this.supplierSelect) {
        this.$router.push('/Supplier/' + this.supplierSelect)
      } else {
        this.$router.push('/Supplier')
      }
    },

    save () {
      this.savingSaveJob = true
      let sortedTemplates = ['preCheck']
      let deviceArray = []
      this.templates.forEach(template => {
        for (let t of this.editedItem.templateExtras) {
          if (t.product.devices.includes(template.id)) {
            sortedTemplates.push(template.id)
          }
          for (let d of t.templateDetails) {
            if (d.deviceDetails) {
              deviceArray.push({product: t.product.id, device: d.deviceDetails.id})
            }
          }
        }
      })
      if (!sortedTemplates['Je2nQqSdazW25XWSGkt3']) {
        sortedTemplates.push('Je2nQqSdazW25XWSGkt3')
      }
      this.editedItem.templates = sortedTemplates.filter((item, pos) => sortedTemplates.indexOf(item) === pos)
      this.editedItem.newMethod = true
      this.editedItem.VehicleSite = this.editedItem.VehicleSite || null
      let obj = this.editedItem
      delete obj['productExtras']
      delete obj['templateExtras']
      if (this.editedIndex > -1) {
        fireStore.collection('Jobs').doc(this.editedItem.id).set(obj, {merge: true})
        .then(() => {
          Object.assign(this.jobs[this.editedIndex], obj)
          this.getJobs()
          this.savingSaveJob = false
          for (let device of deviceArray) {
            fireStore.collection('Devices').doc(device.device).set({
              customer: this.editedItem.Customer,
              vehicle: this.editedItem.Vehicle,
              product: device.product
            }, {merge: true})
          }
          this.close()
        })
        .catch(error => {
          this.saveJobFailed = true
          this.savingSaveJob = false
          console.log(error)
        })
      } else {
        const customerIndex = this.customerList.findIndex(customerListObj => {
          return customerListObj.key === obj.Customer
        })
        const shortName = this.customerList[customerIndex]['shortName']
        fireStore.collection('Jobs').where('Customer', '==', obj.Customer).get()
        .then((docRef) => {
          let jobNumbers = []
          docRef.forEach(doc => {
            let JobNo = doc.data().JobNo
            if (JobNo && JobNo.indexOf(shortName) > -1) { // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
              JobNo = JobNo.replace(/\D/g, '')
              jobNumbers.push(JobNo)
            }
          })
          jobNumbers = jobNumbers.sort()
          jobNumbers = jobNumbers.reverse()
          if (jobNumbers.length === 0) {
            jobNumbers.push(0)
          }
          this.editedItem.JobNo = shortName + this.zeroFill(parseInt(jobNumbers[0]) + 1, 4)
          obj.CreatedDate = Date.now()
          fireStore.collection('Jobs').add(obj)
          .then((docRef) => {
            this.editedItem.id = docRef.id
            obj.id = docRef.id
            this.jobs.push(obj)
            for (let device of deviceArray) {
              fireStore.collection('Devices').doc(device.device).set({
                customer: this.editedItem.Customer,
                vehicle: this.editedItem.Vehicle,
                product: device.product
              }, {merge: true})
            }
            this.getJobs()
            this.close()
            this.savingSaveJob = false
          })
          .catch(error => {
            console.log(error)
            this.saveJobFailed = true
            this.savingSaveJob = false
          })
        })
        .catch(error => {
          this.savingSaveJob = false
          this.saveJobFailed = true
          console.log(error)
        })
      }
    },
    addAdditionalField () {
      if (this.editedItem.additionalFields === undefined) {
        this.editedItem.additionalFields = []
      }
      this.editedItem.additionalFields.push({fieldName: '', fieldValue: ''})
    },
    closeProject () {
      this.projectDialog = false
      this.editedProject = this.defaultProject
    },
    editProject (item) {
      this.editedProjectIndex = this.projects.indexOf(item)
      this.editedProject = Object.assign({}, item)
      this.projectDialog = true
    },
    deleteProject (deleteJobs) {
      if (deleteJobs === true) {
        this.deletingProjectAll = true
      } else {
        this.deletingProjectOnly = true
      }
      const vm = this
      let index = this.projects.findIndex(function (obj) {
        return obj.id === vm.deleteProjectData.id
      })
      fireStore.collection('Projects').doc(vm.deleteProjectData.id)
      .delete()
      .then(() => {
        this.projects.splice(index, 1)
      })
      .catch(error => {
        console.log(error)
      })
      .then(() => {
        this.editedProject = this.defaultProject
        this.deleteProjectData = {}
        this.deleteProjectDialog = false
        this.projectDialog = false
        this.setProjectStates()
        this.deletingProjectAll = false
        this.deletingProjectOnly = false
      })
    },
    deleteProjectModal (item) {
      this.deleteProjectData = item
      this.deleteProjectDialog = true
    },
    saveProject () {
      this.savingSaveProject = true
      let obj = this.editedProject
      if (this.editedProjectIndex > -1) {
        fireStore.collection('Projects').doc(this.editedProject.id).set(obj, {merge: true})
        .then(() => {
          Object.assign(this.projects[this.editedProjectIndex], obj)
          this.projectDialog = false
          this.setProjectStates()
          this.savingSaveProject = false
        })
        .catch(error => {
          console.log(error)
          this.savingSaveProject = false
        })
      }
    },
    addJobsToProject () {
      this.savingAddJobsToProject = true
      const project = this.assignToProject
      let batch = fireStore.batch()
      let vmJobs = this.jobs
      this.selected.forEach((job, index) => {
        const ref = fireStore.collection('Jobs').doc(job.id)
        batch.update(ref, {Project: project})
      })
      batch.commit()
      .then(() => {
        this.selected.forEach((job, index) => {
          const vmIndex = vmJobs.findIndex(vmJob => {
            return vmJob.id === job.id
          })
          vmJobs[vmIndex]['Project'] = project
        })
        this.jobs = vmJobs
      })
      .catch(error => {
        console.log(error)
      })
      .then(() => {
        this.assignToProject = null
        this.savingAddJobsToProject = false
        this.addToProjectDialog = false
      })
    },
    assignJobsToEngineer () {
      this.savingAssignJobsToEngineer = true
      const supplier = this.supplier
      const engineer = this.assignToEngineer
      const date = this.assignToEngineerDate

      let batch = fireStore.batch()
      let vmJobs = this.jobs
      this.selected.forEach((job, index) => {
        const ref = fireStore.collection('Jobs').doc(job.id)
        let obj = {Allocated: engineer, Supplier: supplier}
        if (date) {
          obj.Date = date
        }
        batch.update(ref, obj)
      })
      batch.commit()
      .then(() => {
        this.selected.forEach((job, index) => {
          const vmIndex = vmJobs.findIndex(vmJob => {
            return vmJob.id === job.id
          })
          vmJobs[vmIndex]['Supplier'] = supplier
          vmJobs[vmIndex]['Allocated'] = engineer
        })
        this.jobs = vmJobs
        this.assignToProject = null
      })
      .catch(error => {
        console.log(error)
      })
      .then(() => {
        this.savingAssignJobsToEngineer = false
        this.assignToEngineer = ''
        this.assignToEngineerDate = null
        this.assignToEngineerDialog = false
      })
    },
    uploadInvoice (f) {
      console.log(f)
      let promises = []
      let downloadUrls = []
      let fileObj = {Progress: 0, State: 0, file: f}
      let split = f.name.split('.')
      split.splice(split.length - 1, 0, Date.now())
      let filename = split.join('.')
      const storageRef = storage.ref('Invoices/' + this.supplier)
      promises.push(new Promise((resolve, reject) => {
        let uploadTask = storageRef.child(filename).put(fileObj.file)
        uploadTask.on('state_changed', snapshot => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          fileObj['Progress'] = progress
          this.fileProgress = progress
        }, error => {
          // Handle unsuccessful uploads
          fileObj['State'] = 4
          reject(error)
        }, () => {
          // Handle successful uploads on complete
          fileObj['Progress'] = 100
          this.fileProgress = 100
          fileObj['State'] = 3
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            downloadUrls.push({downloadUrl: downloadURL, name: filename})
            resolve()
          })
        })
      }))

      Promise.all(promises).then(val => {
        let jobNos = []
        for (let job of this.selected) {
          jobNos.push(job.JobNo)
        }
        return fireStore.collection('Invoices').add({
          attachedDocs: downloadUrls,
          supplier: this.supplier,
          status: 0,
          cost: this.totalSelectedCost,
          currency: this.selected[0].currency || '£',
          jobs: jobNos,
          invoiceNumber: this.invoiceNumber,
          submittedDate: moment().format('YYYY-MM-DD')
        })
      })
      .then(() => {
        updateAuditLog('update', 'supplier', this.userData, null, null, 'Added Invoice', this.invoiceNumber, null)
        this.createInvoiceDialog = false
        this.fileProgress = 0
        this.invoiceNumber = ''
        this.selected = []
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style>
  .v-small-dialog__content {
    padding: 2px;
  }
</style>


// WEBPACK FOOTER //
// Supplier.vue?8c185af6